var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarrerGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 483,
    height: 301,
    viewBox: "0 0 483 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3047 92.3625H428.152",
    stroke: "#D5CBC6",
    strokeWidth: 2.62376,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M423.27 299.159H59.1873C56.4907 299.159 54.3047 296.973 54.3047 294.277V72.7378C54.3047 70.042 56.4907 67.8559 59.1873 67.8559H423.27C425.966 67.8559 428.152 70.042 428.152 72.7378V294.277C428.152 296.973 425.966 299.159 423.27 299.159Z",
    stroke: "#D5CBC6",
    strokeWidth: 2.62376,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9431 80.3598C78.9431 82.2478 77.4114 83.7788 75.5233 83.7788C73.6345 83.7788 72.1035 82.2478 72.1035 80.3598C72.1035 78.471 73.6345 76.94 75.5233 76.94C77.4114 76.94 78.9431 78.471 78.9431 80.3598Z",
    fill: "#F79395"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2314 80.3598C92.2314 82.2478 90.7004 83.7788 88.8116 83.7788C86.9228 83.7788 85.3926 82.2478 85.3926 80.3598C85.3926 78.471 86.9228 76.94 88.8116 76.94C90.7004 76.94 92.2314 78.471 92.2314 80.3598Z",
    fill: "#D5C23E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.523 80.3598C105.523 82.2478 103.991 83.7788 102.103 83.7788C100.215 83.7788 98.6836 82.2478 98.6836 80.3598C98.6836 78.471 100.215 76.94 102.103 76.94C103.991 76.94 105.523 78.471 105.523 80.3598Z",
    fill: "#30867A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M476.717 174.906H388.856C386.379 174.906 384.371 172.898 384.371 170.421V89.1629C384.371 86.6856 386.379 84.6777 388.856 84.6777H476.717C479.194 84.6777 481.203 86.6856 481.203 89.1629V170.421C481.203 172.898 479.194 174.906 476.717 174.906Z",
    fill: "#E7E5E4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M476.717 174.906H388.856C386.379 174.906 384.371 172.898 384.371 170.421V89.1629C384.371 86.6856 386.379 84.6778 388.856 84.6778H476.717C479.194 84.6778 481.203 86.6856 481.203 89.1629V170.421C481.203 172.898 479.194 174.906 476.717 174.906Z",
    stroke: "#D5CBC6",
    strokeWidth: 2.62376,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M410.097 151.435H455.763C458.253 151.435 460.272 149.416 460.272 146.926V109.501C460.272 107.012 458.253 104.994 455.763 104.994H410.097C407.608 104.994 405.59 107.012 405.59 109.501V146.926C405.59 149.416 407.608 151.435 410.097 151.435Z",
    fill: "#AF61B7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M445.402 135.936H420.168V119.013H445.402V123.243V135.936Z",
    stroke: "white",
    strokeWidth: 2.19547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M420.168 119.013L432.786 128.956L445.402 119.013",
    stroke: "white",
    strokeWidth: 2.19547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.069 242.949H6.2769C3.91457 242.949 2 241.034 2 238.671V165.616C2 163.254 3.91457 161.339 6.2769 161.339H90.069C92.4309 161.339 94.3467 163.254 94.3467 165.616V238.671C94.3467 241.034 92.4309 242.949 90.069 242.949Z",
    fill: "#E7E5E4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.069 242.949H6.2769C3.91457 242.949 2 241.034 2 238.671V165.616C2 163.254 3.91457 161.339 6.2769 161.339H90.069C92.4309 161.339 94.3467 163.254 94.3467 165.616V238.671C94.3467 241.034 92.4309 242.949 90.069 242.949Z",
    stroke: "#D5CBC6",
    strokeWidth: 2.62376,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.684 227.226H26.2264C23.4813 227.226 21.2559 225.001 21.2559 222.256V180.286C21.2559 177.541 23.4813 175.316 26.2264 175.316H69.684C72.4293 175.316 74.655 177.541 74.655 180.286V222.256C74.655 225.001 72.4293 227.226 69.684 227.226Z",
    fill: "#F79395"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8716 200.873H55.3816C55.3465 198.922 55.0927 196.971 54.6098 195.021H60.1205C61.1155 196.766 61.7354 198.754 61.8716 200.873ZM60.1205 208.492H54.4354C54.9489 206.541 55.2596 204.59 55.3547 202.639H61.8716C61.7354 204.759 61.1162 206.746 60.1205 208.492ZM52.0532 214.847C52.7936 213.317 53.4157 211.788 53.9143 210.258H58.9212C57.1836 212.429 54.7962 214.057 52.0532 214.847ZM48.2801 215.377C47.6752 215.377 47.0793 215.337 46.4961 215.261C45.6636 213.593 44.9546 211.926 44.3841 210.258H52.1752C51.6048 211.926 50.8958 213.593 50.0648 215.261C49.4801 215.337 48.885 215.377 48.2801 215.377ZM37.6389 210.258H42.6458C43.1444 211.787 43.7665 213.317 44.5062 214.847C41.7639 214.057 39.3758 212.429 37.6389 210.258ZM36.4396 208.492C35.4439 206.746 34.8241 204.759 34.6884 202.639H41.2054C41.3005 204.59 41.6104 206.541 42.1248 208.492H36.4396ZM36.4396 195.021H41.9503C41.4674 196.971 41.2137 198.922 41.1785 200.873H34.6884C34.8241 198.754 35.4439 196.766 36.4396 195.021ZM44.3213 188.721C43.5547 190.232 42.9333 191.744 42.4504 193.255H37.6389C39.3368 191.132 41.6561 189.529 44.3213 188.721ZM48.2801 188.135C49.0062 188.135 49.7182 188.193 50.4129 188.302C51.3383 189.953 52.0629 191.604 52.602 193.255H43.9582C44.4972 191.604 45.2219 189.953 46.1472 188.302C46.8419 188.193 47.5546 188.135 48.2801 188.135ZM53.7646 202.639C53.6313 204.59 53.278 206.541 52.727 208.492H43.8324C43.2822 206.541 42.9288 204.59 42.7955 202.639H53.7646ZM42.7364 200.873C42.7386 198.922 42.9685 196.971 43.4513 195.021H53.1088C53.5917 196.971 53.8215 198.922 53.8237 200.873H42.7364ZM58.9212 193.255H54.1097C53.6268 191.744 53.0055 190.232 52.2389 188.721C54.904 189.529 57.2233 191.132 58.9212 193.255ZM37.6045 191.08C31.7412 196.944 31.7412 206.568 37.6045 212.432C43.4678 218.296 53.0923 218.296 58.9557 212.432C64.819 206.568 64.819 196.944 58.9557 191.08C53.0923 185.217 43.4678 185.217 37.6045 191.08Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0744 46.5115H9.16373C7.59571 46.5115 6.32422 45.2403 6.32422 43.6719C6.32422 42.1042 7.59571 40.8323 9.16373 40.8323H85.0744C86.6428 40.8323 87.914 42.1042 87.914 43.6719C87.914 45.2403 86.6428 46.5115 85.0744 46.5115Z",
    fill: "#AF61B7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M479.811 231.937H442.967C441.399 231.937 440.127 230.666 440.127 229.098C440.127 227.53 441.399 226.258 442.967 226.258H479.811C481.379 226.258 482.65 227.53 482.65 229.098C482.65 230.666 481.379 231.937 479.811 231.937Z",
    fill: "#62CBCF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M454.005 264.785H449.504C448.321 264.785 447.361 263.826 447.361 262.643V258.417C447.361 257.234 448.321 256.276 449.504 256.276H454.005C455.189 256.276 456.148 257.234 456.148 258.417V262.643C456.148 263.826 455.189 264.785 454.005 264.785Z",
    fill: "#AF61B7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2457 284.458H22.7434C21.5605 284.458 20.6016 283.499 20.6016 282.316V278.09C20.6016 276.908 21.5605 275.948 22.7434 275.948H27.2457C28.4287 275.948 29.3879 276.908 29.3879 278.09V282.316C29.3879 283.499 28.4287 284.458 27.2457 284.458Z",
    fill: "#F79395"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M371.824 43.5782H296.898C295.652 43.5782 294.643 42.5691 294.643 41.3234V23.0296C294.643 21.7846 295.652 20.7755 296.898 20.7755H371.824C373.07 20.7755 374.079 21.7846 374.079 23.0296V41.3234C374.079 42.5691 373.07 43.5782 371.824 43.5782Z",
    fill: "#F79395"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M305.465 28.9006H358.751",
    stroke: "white",
    strokeWidth: 1.57375,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M305.465 34.3692H327.17",
    stroke: "white",
    strokeWidth: 1.57375,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M303.297 40.9985V49.8856L314.474 40.9985H303.297Z",
    fill: "#F79395"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M187.74 44.9348H151.47C147.947 44.9348 145.092 42.0787 145.092 38.5564V4.83621C145.092 2.16507 147.257 0 149.927 0H187.74C190.411 0 192.576 2.16507 192.576 4.83621V40.0986C192.576 42.7697 190.411 44.9348 187.74 44.9348Z",
    fill: "#62CBCF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M178.803 28.3008C178.61 28.4939 178.417 28.6871 178.224 28.8802C177.885 29.1699 177.596 29.5083 177.258 29.846C176.775 30.3288 176.244 30.5706 175.52 30.5706C175.423 30.5706 175.375 30.5706 175.279 30.5706C173.83 30.4741 172.478 29.8946 171.512 29.4118C168.76 28.0597 166.346 26.1769 164.319 23.7625C162.677 21.7824 161.567 19.8996 160.793 17.9202C160.311 16.7613 160.117 15.8442 160.215 14.9263C160.262 14.3955 160.456 13.9127 160.891 13.5264L162.532 11.8846C162.677 11.7401 162.918 11.547 163.208 11.547C163.497 11.547 163.69 11.6915 163.884 11.8846C164.173 12.1743 164.463 12.4641 164.753 12.7538C164.898 12.899 165.043 13.0914 165.236 13.2367L166.588 14.5887C166.732 14.7332 166.925 15.0229 166.925 15.2647C166.925 15.5544 166.732 15.7955 166.588 15.94C166.442 16.0852 166.298 16.2305 166.153 16.375C165.719 16.8099 165.332 17.1955 164.946 17.5818C164.946 17.5818 164.946 17.5818 164.898 17.6304C164.415 18.1133 164.512 18.5483 164.608 18.8372V18.8859C164.946 19.7551 165.477 20.5269 166.201 21.4934C167.553 23.1831 169.002 24.4864 170.595 25.5009C170.788 25.6453 171.029 25.7419 171.223 25.8385C171.416 25.9351 171.561 25.9837 171.705 26.0803L171.754 26.1282C172.236 26.3693 172.719 26.2727 173.106 25.8872L174.796 24.1967C174.94 24.0522 175.182 23.8591 175.472 23.8591C175.714 23.8591 175.955 24.0522 176.099 24.1967L178.803 26.9008C179.238 27.335 179.238 27.8179 178.803 28.3008ZM179.913 25.7906L177.21 23.0865C176.727 22.555 176.099 22.2653 175.472 22.2653C174.844 22.2653 174.216 22.5549 173.733 23.0386L172.188 24.583C172.092 24.5351 171.995 24.4865 171.899 24.4385C171.705 24.342 171.561 24.2933 171.416 24.1967C169.967 23.2796 168.664 22.0721 167.408 20.5269C166.829 19.803 166.395 19.1277 166.153 18.5482C166.54 18.2099 166.877 17.8236 167.215 17.4859C167.36 17.3407 167.505 17.1954 167.65 17.051C168.181 16.5202 168.471 15.8921 168.471 15.2647C168.471 14.6366 168.181 14.0092 167.65 13.4777L166.298 12.1264C166.153 11.9812 166.008 11.8367 165.863 11.6435C165.574 11.3538 165.236 11.0162 164.946 10.7257C164.463 10.2429 163.836 9.95388 163.208 9.95388C162.58 9.95388 162.001 10.1949 161.47 10.7257L159.78 12.4162C159.152 13.0435 158.766 13.8648 158.669 14.7819C158.573 16.2305 158.959 17.5817 159.297 18.4517C160.069 20.6721 161.276 22.6516 163.063 24.7762C165.236 27.335 167.795 29.3638 170.788 30.8117C171.899 31.3425 173.444 31.9706 175.134 32.1151C175.23 32.1151 175.327 32.1151 175.472 32.1151C176.631 32.1151 177.596 31.6809 178.368 30.8596C178.368 30.8596 178.368 30.8596 178.417 30.8117C178.659 30.522 178.948 30.2323 179.286 29.9425C179.479 29.7494 179.721 29.5083 179.913 29.3152C180.928 28.2529 180.928 26.8042 179.913 25.7906Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_413_163",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 49,
    width: 345,
    height: 250
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M432.564 298.555H88.7344V49.494H432.564V298.555Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_413_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.511 215.067L318.184 211.429L318.397 214.143L295.033 217.253C295.033 217.253 279.974 255.037 293.246 338.132H312.252L319.091 253.874H321.521L328.146 338.132H347.152C360.425 255.037 345.511 215.067 345.511 215.067Z",
    fill: "#826467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.404 253.874H330.233",
    stroke: "#28262C",
    strokeWidth: 1.64441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.471 175.209C359.133 171.477 346 171.609 345.307 171.528C341.757 171.112 347.583 199.362 354.969 224.058C356.385 228.792 361.594 231.258 366.144 229.329C366.193 229.308 366.242 229.287 366.291 229.267C369.891 227.742 371.938 223.921 371.214 220.08C367.702 201.446 364.174 179.524 361.471 175.209Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.599 185.424L347.832 191.931L346.26 183.976L363.622 179.645L364.599 185.424Z",
    fill: "#EC767F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.765 201.34C367.765 201.34 359.822 212.007 360.201 211.517C360.579 211.026 366.429 194.278 366.429 194.278L367.765 201.34Z",
    fill: "#EC767F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.122 187.002L356.355 216.5C353.365 220.373 354.32 225.973 358.424 228.637C362.52 231.296 368.015 229.899 370.341 225.604L389.293 190.639L379.122 187.002Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.015 194.576C380.079 192.982 377.371 187.689 378.965 182.752C380.56 177.817 385.853 175.109 390.789 176.703C395.725 178.297 398.434 183.591 396.839 188.527C395.244 193.463 389.951 196.171 385.015 194.576Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.75 179.994C394.75 179.994 397.32 177.326 392.76 175.455C388.201 173.585 382.564 174.014 378.965 182.752L394.75 179.994Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.475 161.352L409.009 165.485C409.539 165.715 409.732 166.344 409.439 166.89L396.899 190.315C396.607 190.86 395.94 191.117 395.41 190.886L385.876 186.754C385.346 186.523 385.153 185.894 385.444 185.349L397.986 161.924C398.278 161.378 398.945 161.122 399.475 161.352Z",
    fill: "#3B3261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.563 160.937L408.096 165.07C408.627 165.3 408.82 165.929 408.527 166.475L395.986 189.9C395.695 190.445 395.028 190.701 394.497 190.472L384.964 186.338C384.434 186.109 384.24 185.48 384.533 184.934L397.074 161.509C397.366 160.963 398.033 160.707 398.563 160.937Z",
    fill: "#2D2446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.486 163.321L405.863 166.952L395.641 186.043L387.266 182.413L397.486 163.321Z",
    fill: "#DFDCDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.863 166.952L387.266 182.412L397.486 163.321L405.863 166.952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.025 174.678C390.025 174.678 392.147 175.092 394.063 176.177C394.907 176.655 395.339 177.629 395.106 178.571C394.891 179.429 394.173 180.067 393.295 180.178L388.339 180.803C388.339 180.803 385.753 185.26 382.375 185.76L385.474 177.935L390.025 174.678Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.73 138.062C326.183 138.058 361.876 143 367.765 183.695L349.244 186.532L345.511 217.253H293.842L283.584 160.492C283.584 160.492 295.031 144.087 316.285 138.062H326.73Z",
    fill: "#62CBCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.244 186.532L350.851 168.764",
    stroke: "#28262C",
    strokeWidth: 1.64441,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.124 138.643V124.508H313.559V138.81C312.712 139.063 311.3 139.573 309.109 140.614L322.028 148.31L335.236 140.614C335.236 140.614 333.139 139.394 330.124 138.643Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.404 126.235C313.404 126.235 316.379 134.134 324.32 133.452C331.619 132.826 330.458 121.878 330.458 121.878L313.404 126.235Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.18 115.73C303.584 118.085 297.778 109.152 300.287 106.644C302.796 104.137 304.71 108.071 304.71 108.071L305.83 110.738L306.674 114.349L306.875 115.295L306.18 115.73Z",
    fill: "#EC767F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.5 109.809C301.5 109.809 303.465 108.925 305.211 111.773",
    stroke: "#28262C",
    strokeWidth: 1.32378,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.884 115.459C339.272 118.025 345.813 109.616 343.525 106.905C341.238 104.193 338.998 107.952 338.998 107.952L337.656 110.514L336.509 114.041L336.229 114.966L336.884 115.459Z",
    fill: "#EC767F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.048 109.955C342.048 109.955 340.165 108.907 338.184 111.599",
    stroke: "#28262C",
    strokeWidth: 1.32378,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.627 98.124C301.627 109.948 310.642 115.555 321.763 115.555C332.883 115.555 341.898 109.948 341.898 98.124C341.898 86.2993 332.883 78.2552 321.763 78.2552C310.642 78.2552 301.627 86.2993 301.627 98.124Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.362 98.946C304.362 106.205 305.388 112.469 306.411 116.915C307.414 121.267 310.234 124.309 314.22 126.757L314.946 127.203C319.164 129.794 324.612 129.854 328.894 127.358C333.213 124.84 336.237 121.521 337.168 116.85C338.86 108.355 339.045 98.946 339.045 98.946C339.045 98.946 340.656 80.6224 321.952 80.978C303.246 81.3343 304.362 98.946 304.362 98.946Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.57 109.404V111.939C320.57 112.089 320.599 112.234 320.652 112.365C320.86 112.883 321.458 113.132 321.999 112.988L323.161 112.68",
    stroke: "#28262C",
    strokeWidth: 1.64217,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.595 99.5712L308.299 101.75C308.299 101.75 308.722 99.384 312.524 98.5238C316.327 97.6644 317.595 99.5712 317.595 99.5712Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.846 99.5712L334.821 101.75C334.821 101.75 334.413 99.384 330.741 98.5238C327.07 97.6644 325.846 99.5712 325.846 99.5712Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.631 106.399C315.631 107.263 314.929 107.963 314.064 107.963C313.198 107.963 312.496 107.263 312.496 106.399C312.496 105.536 313.198 104.836 314.064 104.836C314.929 104.836 315.631 105.536 315.631 106.399Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.493 106.399C330.493 107.263 329.791 107.963 328.926 107.963C328.06 107.963 327.357 107.263 327.357 106.399C327.357 105.536 328.06 104.836 328.926 104.836C329.791 104.836 330.493 105.536 330.493 106.399Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.631 115.939H327.721C327.721 115.939 322.363 122.458 315.631 115.939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.071 107.007C320.071 110.688 317.087 113.673 313.405 113.673C309.723 113.673 306.738 110.688 306.738 107.007C306.738 103.325 309.723 100.34 313.405 100.34C317.087 100.34 320.071 103.325 320.071 107.007Z",
    stroke: "#AF61B7",
    strokeWidth: 1.78973,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.448 107.007C336.448 110.688 333.464 113.673 329.783 113.673C326.101 113.673 323.115 110.688 323.115 107.007C323.115 103.325 326.101 100.34 329.783 100.34C333.464 100.34 336.448 103.325 336.448 107.007Z",
    stroke: "#AF61B7",
    strokeWidth: 1.78973,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.07 107.007C320.07 107.007 321.649 105.533 323.114 107.007",
    stroke: "#AF61B7",
    strokeWidth: 1.78973,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.739 107.007L304.639 106.953",
    stroke: "#AF61B7",
    strokeWidth: 1.78973,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.447 107.007L338.56 106.953",
    stroke: "#AF61B7",
    strokeWidth: 1.78973,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.804 105.021C338.804 105.021 331.326 94.9116 333.051 84.6695C333.051 84.6695 338.602 87.4627 340.048 94.672C341.493 101.882 338.804 105.021 338.804 105.021Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.35 105.706C304.35 105.706 313.038 94.2236 311.312 83.9815C311.312 83.9815 305.287 87.4627 303.841 94.672C302.396 101.882 304.35 105.706 304.35 105.706Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.177 88.7031C338.177 88.7031 328.575 99.2155 302.303 97.4158C302.303 97.4158 306.326 81.9901 319.058 80.3468C319.058 80.3468 333.759 78.5913 338.177 88.7031Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.047 76.4135C350.047 83.3414 344.431 88.9577 337.503 88.9577C330.575 88.9577 324.959 83.3414 324.959 76.4135C324.959 69.4864 330.575 63.8701 337.503 63.8701C344.431 63.8701 350.047 69.4864 350.047 76.4135Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.375 215.039L161.012 211.928L161.225 209.215L133.898 212.853C133.898 212.853 118.985 252.822 132.257 335.918H151.263L157.888 251.659H160.317L167.158 335.918H186.162C199.436 252.822 184.375 215.039 184.375 215.039Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.51 101.363C179.348 97.6419 176.816 93.3028 174.664 87.2126C172.354 80.6748 164.791 83.3324 164.791 83.3324C164.791 83.3324 158.488 75.2239 149.003 78.0485C139.519 80.8724 136.223 87.6214 136.03 95.6453C135.836 103.67 129.525 104.925 124.665 114.207C116.085 130.595 130.531 144.398 156.826 140.569L156.861 140.314C159.451 141.1 162.624 141.443 166.498 141.213C198.088 139.337 195.039 116.103 182.51 101.363Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.168 113.515C174.764 115.87 180.569 106.938 178.061 104.43C175.553 101.922 173.638 105.857 173.638 105.857L172.519 108.523L171.673 112.134L171.473 113.08L172.168 113.515Z",
    fill: "#EC767F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.848 107.594C176.848 107.594 174.883 106.71 173.137 109.559",
    stroke: "#28262C",
    strokeWidth: 1.32378,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.464 113.244C139.076 115.811 132.536 107.401 134.824 104.69C137.112 101.979 139.351 105.737 139.351 105.737L140.692 108.3L141.84 111.826L142.12 112.752L141.464 113.244Z",
    fill: "#EC767F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.299 107.74C136.299 107.74 138.182 106.693 140.163 109.384",
    stroke: "#28262C",
    strokeWidth: 1.32378,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.724 95.9088C176.724 107.733 167.709 113.34 156.589 113.34C145.468 113.34 136.453 107.733 136.453 95.9088C136.453 84.0848 145.468 76.0407 156.589 76.0407C167.709 76.0407 176.724 84.0848 176.724 95.9088Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.793 143.743H148.229V122.294H164.793V143.743Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.811 120.956C145.811 120.956 150.421 130.158 156.094 131.595C157.609 131.979 159.228 131.847 160.689 131.33C162.824 130.572 165.531 127.389 165.992 123.867L166.205 121.855C166.205 121.855 156.111 127.351 145.811 120.956Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.987 96.7316C173.987 103.99 172.962 110.254 171.938 114.7C170.936 119.052 168.116 122.094 164.129 124.543L163.404 124.988C159.186 127.579 153.737 127.639 149.455 125.143C145.136 122.625 142.112 119.305 141.182 114.635C139.489 106.14 139.304 96.7316 139.304 96.7316C139.304 96.7316 137.694 78.4071 156.399 78.7635C175.103 79.1191 173.987 96.7316 173.987 96.7316Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.338 108.181V109.688C155.338 109.837 155.367 109.981 155.419 110.113C155.628 110.629 156.226 110.876 156.766 110.733L157.93 110.426",
    stroke: "#28262C",
    strokeWidth: 1.63968,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.232 98.2483L169.183 100.604C169.183 100.604 168.731 98.0462 164.66 97.1164C160.589 96.1873 159.232 98.2483 159.232 98.2483Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.009 98.2483L143.93 100.604C143.93 100.604 144.388 98.0462 148.511 97.1164C152.635 96.1873 154.009 98.2483 154.009 98.2483Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.4 104.425C150.4 105.285 149.697 105.984 148.832 105.984C147.966 105.984 147.264 105.285 147.264 104.425C147.264 103.564 147.966 102.866 148.832 102.866C149.697 102.866 150.4 103.564 150.4 104.425Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.26 104.425C165.26 105.285 164.558 105.984 163.693 105.984C162.826 105.984 162.125 105.285 162.125 104.425C162.125 103.564 162.826 102.866 163.693 102.866C164.558 102.866 165.26 103.564 165.26 104.425Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.365 113.34H163.124C163.124 113.34 162.153 117.121 155.914 117.121C151.163 117.121 149.365 113.34 149.365 113.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.543 102.807C139.543 102.807 147.021 92.6964 145.297 82.4543C145.297 82.4543 139.745 85.2474 138.3 92.4576C136.855 99.667 139.543 102.807 139.543 102.807Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.999 102.47C173.999 102.47 165.312 92.0092 167.037 81.7671C167.037 81.7671 173.062 85.2475 174.508 92.4576C175.954 99.667 173.999 102.47 173.999 102.47Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.172 86.4887C140.172 86.4887 148.754 98.0222 175.025 96.2225C175.025 96.2225 172.024 79.7749 159.291 78.1324C159.291 78.1324 144.59 76.3768 140.172 86.4887Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.224 265.773C115.841 266.374 138.09 168.971 131.485 170.443C130.882 170.577 119.313 171.652 117.594 175.148C112.61 185.281 109.035 265.034 109.035 265.034L116.224 265.773Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.035 265.034C109.035 265.034 105.449 281.673 119.005 283.492C119.898 283.612 120.761 283.084 121.056 282.232L121.095 282.119C121.419 281.18 120.948 280.171 120.04 279.766C117.83 278.777 114.402 276.281 116.102 270.61C116.102 270.61 118.062 270.369 119.143 274.025C119.421 274.965 120.477 275.438 121.353 274.997C121.95 274.695 122.287 274.052 122.203 273.388C121.878 270.827 120.59 264.665 115.649 263.012L109.035 265.034Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.596 198.552C113.596 198.552 126.415 216.604 126.483 216.255C126.55 215.906 130.965 190.909 130.965 190.909L115.41 184.171L113.596 198.552Z",
    fill: "#EC767F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.214 140.212C149.76 140.209 117.533 140.786 111.643 181.48L130.164 184.318L133.898 215.039H185.567L195.824 158.277C195.824 158.277 188.532 145.979 167.277 139.954L149.214 140.212Z",
    fill: "#30867A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.463 145.131C133.463 145.131 138.017 151.177 156.678 151.177C175.167 151.177 179.894 144.814 179.894 144.814C179.894 144.814 168.996 138.725 156.349 136.755C156.349 136.755 145.056 138.767 133.463 145.131Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.869 274.049L196.913 355.205H237.062L240.147 274.049H196.869Z",
    fill: "#315384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.042 274.049L283.998 355.205H243.85L240.764 274.049H284.042Z",
    fill: "#315384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.114 302.243H220.602V274.049H262.114V302.243Z",
    fill: "#315384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.406 203.225C311.896 230.725 309.269 250.762 309.996 301.364L286.033 302.368L282.463 207.649L309.406 203.225Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.416 224.684C285.416 224.684 300.256 223.326 310.402 216.634L310.134 210.744L285.408 214.112L285.416 224.684Z",
    fill: "#EC767F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.611 139.909C261.611 139.909 308.746 151.762 317.285 211.589C317.285 211.589 294.217 221.59 271.099 217.289L276.3 197.278L261.611 139.909Z",
    fill: "#AF61B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.822 164.785L155.917 206.23L145.177 236.475C145.177 236.475 118.503 199.389 106.518 170.725L120.822 164.785Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.974 166.281C121.974 166.281 109.651 173.243 106.517 170.725C101.039 166.324 96.5117 150.213 96.5117 150.213C96.5117 150.213 119.557 141.525 119.341 141.864C119.124 142.204 121.974 166.281 121.974 166.281Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.976 166.281C121.758 165.04 126.545 151.656 128.187 146.637C128.582 145.427 127.748 144.099 126.434 143.848C125.579 143.684 124.224 143.79 123.584 145.017L117.803 154.896L121.976 166.281Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.554 151.812L117.585 132.068C117.349 130.754 116.03 129.849 114.713 130.098C113.573 130.313 112.821 131.329 112.955 132.472L114.685 147.173L121.554 151.812Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.661 144.53L108.272 130.431C107.826 129.196 106.437 128.512 105.211 128.923C104.147 129.279 103.549 130.351 103.802 131.452L107.801 147.744L113.661 144.53Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.869 148.687L101.05 134.834C100.425 133.547 98.8674 132.951 97.5895 133.507C96.3887 134.029 95.8572 135.389 96.3715 136.625L101.807 149.704L107.869 148.687Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5128 150.213L91.1623 141.725C90.7199 140.728 91.1286 139.608 92.0981 139.165C93.0257 138.741 94.1719 139.075 94.7715 139.943L101.808 149.704L96.5128 150.213Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.473 150.329C120.473 150.329 112.438 149.486 111.613 160.194",
    stroke: "#28262C",
    strokeWidth: 2.04231,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.061 222.328C138.061 222.328 144.661 245.172 157.814 242.135C170.968 239.099 191.468 211.005 191.468 211.005L186.879 163.037L149.962 208.474L138.061 222.328Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 194.361C161.414 194.361 173.878 213.161 184.51 219.791L191.47 211.005L164.623 190.237L161.414 194.361Z",
    fill: "#EC767F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.942 138.872C215.942 138.872 179.348 147.119 159.848 189.649C159.848 189.649 171.63 207.402 190.519 215.293L203.165 199.8L215.942 138.872Z",
    fill: "#AF61B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.945 138.74C201.65 146.072 192.664 155.796 192.664 155.796L195.484 280.115H285.566L285.274 156.438C285.274 156.438 273.919 145.326 261.612 139.909C251.16 135.307 226.106 133.528 215.945 138.74Z",
    fill: "#AF61B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.569 199.318C251.649 199.318 246.039 193.708 246.039 186.788V174.258H271.098V186.788C271.098 193.708 265.489 199.318 258.569 199.318Z",
    stroke: "#28262C",
    strokeWidth: 1.86241,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.418 217.75L286.587 177.082",
    stroke: "#28262C",
    strokeWidth: 1.86241,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.046 210.972L192.1 175.72",
    stroke: "#28262C",
    strokeWidth: 1.86241,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 93.3328L213.245 74.7553C213.034 73.2423 212.446 70.9073 213.166 68.713C214.355 65.0829 218.726 58.1116 226.197 61.303L227.812 68.6584C227.812 68.6584 220.053 70.2245 216.941 80.3746L217 93.3328Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.648 65.1375C225.512 67.5788 223.358 78.2589 215.783 82.1503C215.783 82.1503 209.149 67.9217 225.648 65.1375Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.219 135.319V103.774H223.139V135.319L214.482 139.265C214.482 139.265 216.513 152.34 237.984 152.629C259.455 152.919 261.612 139.909 261.612 139.909L252.219 135.319Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.195 61.303C226.195 61.303 231.532 47.2241 247.99 54.709C257.951 59.239 260.74 65.3135 261.927 69.6166C262.322 71.0473 262.479 73.2992 262.372 74.6363L258.391 93.3328L242.85 67.4658L227.81 68.6584L226.195 61.303Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.392 93.3327C258.392 93.3327 260.353 90.2147 264.396 91.7479C268.44 93.2818 266.611 103.102 260.545 104.353C260.545 104.353 258.371 104.828 256.666 103.339C256.666 103.339 258.157 96.0855 258.392 93.3327Z",
    fill: "#EC767F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.595 95.2126C263.595 95.2126 260.207 94.0821 257.803 99.0703",
    stroke: "#28262C",
    strokeWidth: 1.86241,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 93.3327C217 93.3327 215.04 90.2147 210.996 91.7479C206.953 93.2818 208.782 103.102 214.847 104.353C214.847 104.353 217.022 104.828 218.727 103.339C218.727 103.339 217.235 96.0855 217 93.3327Z",
    fill: "#EC767F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.797 95.2126C211.797 95.2126 215.184 94.0821 217.588 99.0703",
    stroke: "#28262C",
    strokeWidth: 1.86241,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.795 84.0137C258.797 89.9339 258.216 102.32 254.577 109.671C251.16 116.573 245.507 120.287 238.098 120.509C230.688 120.73 225.168 117.875 220.745 108.916C216.321 99.9582 216.533 84.1238 216.533 84.1238C216.533 84.1238 216.533 62.9755 237.434 62.9755C259.449 62.9755 258.795 84.0137 258.795 84.0137Z",
    fill: "#F79395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.355 113.331C223.355 113.331 225.791 125.688 236.544 127.108C248.921 128.741 252.217 113.646 252.217 113.646C252.217 113.646 246.748 120.499 238.099 120.509C228.453 120.521 223.355 113.331 223.355 113.331Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.176 92.7938V97.6883C236.176 97.8987 236.216 98.1001 236.29 98.2843C236.58 99.0097 237.414 99.3571 238.169 99.1564L239.791 98.7245",
    stroke: "#28262C",
    strokeWidth: 1.86241,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.001 90.4565C230.001 91.5076 229.149 92.3595 228.098 92.3595C227.047 92.3595 226.195 91.5076 226.195 90.4565C226.195 89.4062 227.047 88.5534 228.098 88.5534C229.149 88.5534 230.001 89.4062 230.001 90.4565Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.843 90.4565C247.843 91.5076 246.99 92.3595 245.94 92.3595C244.889 92.3595 244.037 91.5076 244.037 90.4565C244.037 89.4062 244.889 88.5534 245.94 88.5534C246.99 88.5534 247.843 89.4062 247.843 90.4565Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.068 80.99L253.862 84.2952C253.862 84.2952 253.28 80.7062 248.046 79.4028C242.813 78.0987 241.068 80.99 241.068 80.99Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.118 80.99L220.324 84.2952C220.324 84.2952 220.906 80.7062 226.139 79.4028C231.373 78.0987 233.118 80.99 233.118 80.99Z",
    fill: "#28262C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.574 102.62C230.574 102.62 232.462 104.066 237.424 104.066C241.938 104.066 244.757 102.62 244.757 102.62",
    stroke: "#28262C",
    strokeWidth: 1.86241,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.673 91.012C235.673 95.4776 232.053 99.098 227.587 99.098C223.122 99.098 219.502 95.4776 219.502 91.012C219.502 86.5471 223.122 82.9267 227.587 82.9267C232.053 82.9267 235.673 86.5471 235.673 91.012Z",
    stroke: "white",
    strokeWidth: 2.60191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.537 91.012C255.537 95.4776 251.917 99.098 247.451 99.098C242.986 99.098 239.365 95.4776 239.365 91.012C239.365 86.5471 242.986 82.9267 247.451 82.9267C251.917 82.9267 255.537 86.5471 255.537 91.012Z",
    stroke: "white",
    strokeWidth: 2.60191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.674 91.012C235.674 91.012 237.589 89.225 239.365 91.012",
    stroke: "white",
    strokeWidth: 2.60191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.502 91.012L216.791 90.9438",
    stroke: "white",
    strokeWidth: 2.60191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.537 91.012L258.564 90.9633",
    stroke: "white",
    strokeWidth: 2.60191,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.355 65.6212C223.355 65.6212 227.239 76.6523 244.759 76.314C256.665 76.0841 259.51 84.6995 259.51 84.6995C259.51 84.6995 257.438 65.4392 256.893 65.6212C256.349 65.8023 238.777 60.9324 238.777 60.9324L223.355 65.6212Z",
    fill: "#28262C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrerGroup);
export default __webpack_public_path__ + "static/media/carrerGroup.978d28aa7dd691ab6485b3261e4846b0.svg";
export { ForwardRef as ReactComponent };